import React from 'react';
const CarBikeHire = () => <div className="service-page"><h1>Car/Bike Hire</h1><p>Rent cars and bikes at affordable rates.</p></div>;
export default CarBikeHire;
